import { useMemo } from 'react'

import { RouteConfig } from '@app/routing/RenderRoutes'

import { SocialTradingPage } from './SocialTradingPage'

export const useSocialTradingRoutes = (): RouteConfig[] => {
  return useMemo(
    (): RouteConfig[] => [
      {
        path: 'social-trading',
        element: <SocialTradingPage />,
      },
    ],
    []
  )
}
